import { j as t } from "../../../../node_modules/react/jsx-runtime.js";
import { useState as U } from "react";
import W from "../../../../node_modules/lodash/uniqueId.js";
import { clsx as h } from "../../../../node_modules/clsx/dist/clsx.m.js";
import { FieldLabel as X } from "../components/FieldLabel/FieldLabel.js";
import Y from "../components/FieldHelperText/FieldHelperText.js";
import i from "../TextField.module.scss.js";
import q from "./style.module.scss.js";
import D from "./List.js";
const K = ({
  disabled: r = !1,
  dropdownSide: m = "start",
  dropdownValue: l = "",
  helperText: a = "",
  helperTextIcon: p,
  helperTextIconTooltip: E,
  label: u,
  labelIconTooltip: H,
  listItems: F,
  onChange: s,
  optionalLabel: R,
  placeholder: _,
  required: k,
  size: e = "regular",
  testId: x,
  type: A = "text",
  value: f = "",
  status: j,
  id: n,
  minWidth: B,
  maxWidth: G,
  direction: I,
  valueKey: d,
  labelKey: v,
  subLabelKey: N,
  avatarSrcKey: T,
  autoComplete: J = "off",
  readOnly: o = !1
}) => {
  const [$] = U(() => W("")), M = (c) => {
    o || s == null || s(c.target.value, l, c);
  }, L = (c, P) => {
    const Q = P;
    s == null || s(f, Q.value);
  };
  return /* @__PURE__ */ t.jsxs(
    "div",
    {
      className: h(
        i.fieldContainer,
        q.dropdownFieldContainer,
        i[`container-${e}`],
        r && i.disabled,
        { "pointer-events-none": r }
      ),
      style: { minWidth: B, maxWidth: G, direction: I },
      children: [
        u && /* @__PURE__ */ t.jsx(
          X,
          {
            label: u,
            optionalLabel: R,
            required: k,
            disabled: r,
            tooltipText: H,
            size: e,
            htmlFor: n || $,
            withTextField: !0
          }
        ),
        /* @__PURE__ */ t.jsxs(
          "div",
          {
            className: h(i.textField, i[e], {
              [i.textFilled]: !!f,
              [i.readOnly]: o
            }),
            "aria-disabled": r,
            "data-destructive": j === "destructive",
            children: [
              m === "start" && /* @__PURE__ */ t.jsx(
                D,
                {
                  dropdownSide: m,
                  listItems: F,
                  size: e,
                  value: l,
                  onChange: L,
                  testId: `${x}-list`,
                  valueKey: d,
                  labelKey: v,
                  subLabelKey: N,
                  avatarSrcKey: T,
                  readOnly: o
                }
              ),
              /* @__PURE__ */ t.jsx(
                "input",
                {
                  type: A,
                  id: n || $,
                  placeholder: _,
                  value: f,
                  className: q.input,
                  onChange: M,
                  disabled: r,
                  "data-testid": x,
                  autoComplete: J,
                  readOnly: o
                }
              ),
              m === "end" && /* @__PURE__ */ t.jsx(
                D,
                {
                  dropdownSide: m,
                  listItems: F,
                  value: l,
                  onChange: L,
                  size: e,
                  testId: `${x}-list`,
                  valueKey: d,
                  labelKey: v,
                  subLabelKey: N,
                  avatarSrcKey: T,
                  readOnly: o
                }
              )
            ]
          }
        ),
        (a || p) && /* @__PURE__ */ t.jsx(
          Y,
          {
            label: a,
            disabled: r,
            icon: p,
            tooltipText: E,
            status: j,
            withTextField: !0
          }
        )
      ]
    }
  );
};
export {
  K as default
};
//# sourceMappingURL=DropdownField.js.map
